import GenericBody from "../Componentes/GenericBody";
import GenericHeader from "../Componentes/GenericHeader";
import NavBar from "../Componentes/NavBar";
//import Tabela from "../Componentes/Tabela";
import Filters from "../Componentes/Utils/Filters";
import Stats from "../Componentes/Utils/Stats";
import FilterContainer from "../Componentes/Utils/FilterContainer";
import FormContainer from "../Componentes/Utils/FormContainer";

import { formatarData } from "../Funcoes/FormatarData";
import { useEffect, useRef, useState, useMemo, useCallback, useContext } from "react";
import { useParams, useNavigate, useLocation, replace } from "react-router-dom";
import { saveAs } from "file-saver";
import Overlay from "../Componentes/Overlay";

import { HiOutlineDownload } from "react-icons/hi";
import { MdOutlineAdd } from "react-icons/md";
import { LuFileDown } from "react-icons/lu";
import { TbLoader2 } from "react-icons/tb";
import { IoClose } from "react-icons/io5";

import SideMenu from "../Componentes/SideMenu";
import SideMenuBtn from "../Componentes/SideMenuBtn";
import FormTreinamentos from "../Componentes/Treinamentos/FormTreinamentos";
import SaveAnexos from "../Componentes/Treinamentos/SaveAnexos";
import { VerifyPermission } from "../Funcoes/VerifyPermission";
import { AuthContext } from "../Auth/AuthProvider";
import styled, { keyframes } from "styled-components"

import { IoTrashOutline } from "react-icons/io5";
import { pdf } from "@react-pdf/renderer";
import DocumentoCracha from "../Modulos/Treinamentos/cracha/DocumentoCracha";
import { useModal } from "../contexts/ModalContext";
import AddTreinamentoModal from "../Modulos/Treinamentos/AddTreinamentoModal";
import ModalAddedTreinamentos from "../Modulos/Treinamentos/ModalAddedTreinamentos";
import useApi from "../hooks/useApi";
import Tabela2 from "../Componentes/Utils/Tabela2";

const fadeIn = keyframes`
    from{
        opacity: 0;
    }
    to{
        opacity: 1;
    }
`
const spin = keyframes`
    from { transform: rotate(0deg); }
    to { transform: rotate(360deg); }
`

const ContainerBtnDelete = styled.div`
    width: 20px;
    height: 20px;
    svg{
        width: 100%;
        height: 100%;
        color: red;
        cursor: pointer;
        transition: .3s;
        &:hover{
            scale: 1.1;
        }
    }
`
const ModalDelete = styled.div`
    width: 450px;
    padding: 20px;
    box-sizing: border-box;
    background-color: #fff;
    border: 3px solid #d60202;
    margin: auto;
    border-radius: 12px;
    display: flex;
    flex-direction: column;
    h3{
        margin: 10px auto;
        font-size: 18px;
        color: #333;
        font-weight: bold;
    }
    animation: ${fadeIn} .3s ease-in-out;
`
const ConatinerBtnDelete = styled.div`
    width: 100%;
    display: flex;
    gap: 10px;
    margin: 30px 0 0 0;
`
const Botao = styled.button`
    width: calc( 50% - 5px );
    height: 40px;
    border-radius: 12px;
    outline: none;
    cursor: pointer;
    font-weight: bold;
    transition: .3s;
    &:hover{
        scale: 1.05;
    }
    background-color: ${props => props.tipo === 'confirm' ? "#f00000" : props.tipo === "cancel" ? "#fff" : "gray"};
    color: ${props => props.tipo === 'confirm' ? "#fff" : props.tipo === "cancel" ? "#333" : "gray"};
    border: 2px solid ${props => props.tipo === 'confirm' ? "#b90000" : props.tipo === 'cancel' ? "#333" : "gray"};
`
const ContainerTabela = styled.div`
    width: 100%;
    flex: 1;
    background-color: #f3f3f3;
    border-radius: 8px;
    overflow: auto;
    display: flex;
    flex-direction: column;
    &::-webkit-scrollbar {
        height: 8px;
        width: 12px;
        background-color: #f0f0f0;
    }
    &::-webkit-scrollbar-thumb {
        background-color: #c1c1c1;
        border-radius: 4px;
        border: 3px solid #f0f0f0;
        border-radius: 8px;
    }
`
const Tabela = styled.table`
    width: 100%;
    border-collapse: collapse;
    thead {
        background-color: #f0f0f0;
        position: sticky;
        top: 0;
        th {
            text-align: left;
            padding-left: 12px;
            font-weight: bold;
            white-space: nowrap;
            padding-right: 5px;
        }
        th:last-child{
            padding-right: 15px;
        }
        tr{
            height: 40px;
        }
        box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.1);
    }
    tbody {
        tr {
            height: 35px;
            border-bottom: 1px solid #e1e1e1;
            &:nth-child(even) {
                background-color: #f9f9f9;
            }
            &:nth-child(odd) {
                background-color: #ffffff;
            }
            &:last-child {
                border-bottom: none;
            }
            td {
                padding-left: 12px;
                white-space: nowrap;
                padding-right: 5px;
            }
            &:hover {
                background-color: #e8f0fe;
            }
        }
    }
`
const LinhaTabela = styled.tr`
    color: ${props => props.status === 'VENCIDO' ? '#b30000' : props.status === 'A VENCER' ? '#ff4500' : 'black'};
    cursor: pointer;
`

const ContainerIcones = styled.div`
    display: flex;
    height: 100%;
    gap: 10px;
    padding: 0 15px;
    box-sizing: border-box;
`
const IconeContainer = styled.div`
    display: flex;
    width: 20px;
    height: 20px;
    cursor: pointer;
`

const IconeModelo = styled(LuFileDown)`
    width: 100%;
    height: 100%;
    color: black;
`
const IconeDownload = styled(HiOutlineDownload)`
    width: 100%;
    height: 100%;
    color: green;
`
const IconeAnexar = styled(MdOutlineAdd)`
    width: 100%;
    height: 100%;
    color: red;
`
const IconeLoader = styled(TbLoader2)`
    width: 100%;
    height: 100%;
    color: black;
    animation: ${spin} 1s linear infinite;
`
const IconeDelete = styled(IoTrashOutline)`
    width: 100%;
    height: 100%;
    color: red;
`
const LoadingWrapper = styled.div`
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
`
const LoadingModal = styled.div`
    width: 300px;
    height: 150px;
    background-color: #fff;
    border-radius: 12px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.1);
    p{
        margin: 10px 0 0 0;
        font-weight: bold;
    }
`
const LoadingIcon = styled(TbLoader2)`
    width: 40px;
    height: 40px;
    color: black;
    animation: ${spin} 1s linear infinite;
`


const Treinamentos = () => {

    const { user } = useContext(AuthContext)
    const api = useApi();

    const { id } = useParams();
    const navigate = useNavigate();

    const { openModal, isModalOpen, closeModal } = useModal();

    const location = useLocation();

    const [loadingItem, setLoadingItem] = useState(false);

    const [downloadingPDF, setDownloadingPDF] = useState({});

    const isViewing = location.pathname.includes("view");
    const isEditing = location.pathname.includes("edit");
    const isCreating = location.pathname.includes("new");

    const openedForm = location.pathname.includes("form");

    const [treinamentos, setTreinamentos] = useState([])
    const [treinamentosFilter, setTreinamentosFilter] = useState([])
    const [linhasTabela, setLinhasTabela] = useState(100);
    const [sidebar, setSidebar] = useState(false)

    const tabelaRef = useRef(null);

    const [loadingContent, setLoadingContent] = useState(true)

    const getTreinamentos = async () => {

        setLoadingContent(true);

        try {

            const { data } = await api.get('/Painel/API/Treinamentos/GetTreinamentos');

            setTreinamentos(data)
            setTreinamentosFilter(data)

        } catch (error) {

            console.log(error)

        } finally {

            setLoadingContent(false)

        }

    }

    useEffect(() => {

        getTreinamentos()

    }, [])

    useEffect(() => {

        const element = tabelaRef.current;

        if (!element) return;

        const handleScroll = () => {

            console.log('testando')

            const { scrollTop, scrollHeight, clientHeight } = element;

            if (scrollTop + clientHeight >= scrollHeight - 10) {
                setLinhasTabela((prev) => prev + 100);
            }

        };

        element.addEventListener("scroll", handleScroll);

        return () => {
            element.removeEventListener("scroll", handleScroll);
        };

    }, []);

    const funcoes = useMemo(() => [...new Set(treinamentos.map((obj) => obj.funcao))].sort(), [treinamentos])
    const obras = useMemo(() => [...new Set(treinamentos.map((obj) => obj.local))].sort(), [treinamentos]);
    const contratos = useMemo(() => [...new Set(treinamentos.map((obj) => obj.contrato))].sort(), [treinamentos]);
    //const instrutores = useMemo(() => [...new Set(treinamentos.map((obj) => obj.instrutor))].sort(), [treinamentos]);
    //const instrutores_name = useMemo(() => [...new Set(treinamentos.map((obj) => obj.instrutor_name))].sort(), [treinamentos]);

    const instrutores = [
        ... new Map(
            treinamentos.map(item => [item.nome_instrutor, { label: item.nome_instrutor , value: item.instrutor }])
        ).values()
    ].sort((a, b) => a.label.localeCompare(b.label));

    // Criar um array de objetos únicos para treinamentos, usnado o campo treinamento_id como value e treinamento_nome como label

    const treinamentosOptions = [
        ... new Map(
            treinamentos.map(item => [item.treinamento_id, { label: item.treinamento_nome, value: item.treinamento_id }])
        ).values()
    ].sort((a, b) => a.label.localeCompare(b.label));

    const motivos = useMemo(() => [...new Set(treinamentos.map((obj) => obj.motivo))].sort(), [treinamentos]);
    const processos = useMemo(() => [...new Set(treinamentos.map((obj) => obj.processo))].sort(), [treinamentos]);
    const preenchidos = useMemo(() => [...new Set(treinamentos.map((obj) => obj.email))].sort(), [treinamentos]);

    const [colabName, setColabName] = useState([])
    const [funcSelected, setFuncSelected] = useState([])
    const [obrasSelected, setObrasSelected] = useState([])
    const [contratoSelected, setContratoSelected] = useState([])
    const [instrutoresSelected, setInstrutoresSelected] = useState([])
    const [treinamentosSelected, setTreinamentosSelected] = useState([])
    const [motivosSelected, setMotivosSelected] = useState([])
    const [processosSelected, setProcessosSelected] = useState([])
    const [anexadoSelect, setAnexadoSelect] = useState([])
    const [preenchidosSelected, setPreenchidosSelected] = useState([])
    const [dataIni, setDataIni] = useState('')
    const [dataFim, setDataFim] = useState('')

    const handleChange = (type, value) => {

        switch (type) {
            case 'name':
                setColabName(value)
                break;
            case 'funcao':
                setFuncSelected(value)
                break;
            case 'obra':
                setObrasSelected(value)
                break;
            case 'contrato':
                setContratoSelected(value)
                break;
            case 'instrutor':
                setInstrutoresSelected(value)
                break;
            case 'treinamento':
                setTreinamentosSelected(value)
                break;
            case 'motivo':
                setMotivosSelected(value)
                break;
            case 'processo':
                setProcessosSelected(value)
                break;
            case 'anexado':
                setAnexadoSelect(value)
                break;
            case 'preenchido':
                setPreenchidosSelected(value)
                break;
            case 'data_ini':
                setDataIni(value)
                break;
            case 'data_fim':
                setDataFim(value)
                break;
            default:
                console.log('Opção inválida')
        }

    }

    const handleFilter = useCallback(() => {
        setTreinamentosFilter(
            treinamentos.filter((item) => {
                const nome = !colabName || item.nome.includes(colabName);
                const funcao = !funcSelected.length || funcSelected.some(obj => (item.funcao || '').includes(obj.value));
                const obra = !obrasSelected.length || obrasSelected.some(obj => (item.obra || '').includes(obj.value));
                const contrato = !contratoSelected.length || contratoSelected.some(obj => (item.contrato || '').includes(obj.value));
                const instrut = !instrutoresSelected.length || instrutoresSelected.some(obj => (item.instrutor || '').includes(obj.value));
                const training = !treinamentosSelected.length || treinamentosSelected.some(obj => (item.treinamento_id || '').includes(obj.value));
                const motivo = !motivosSelected.length || motivosSelected.some(obj => (item.motivo || '').includes(obj.value));
                const processo = !processosSelected.length || processosSelected.some(obj => (item.processo || '').includes(obj.value));
                const preenchido = !preenchidosSelected.length || preenchidosSelected.some(obj => (item.email || '').includes(obj.value));

                const anexos =
                    !anexadoSelect.length ||
                    (anexadoSelect.some(obj => obj.value === 'ANEXADO') && item.certificado !== null) ||
                    (anexadoSelect.some(obj => obj.value === 'ANEXO PENDENTE') && item.certificado === null);

                const dataInicio = !dataIni || (item.data_inicio && new Date(item.data_inicio) >= new Date(dataIni));
                const dataTermino = !dataFim || (item.data_termino && new Date(item.data_termino) <= new Date(dataFim));


                return nome && funcao && obra && contrato && instrut && training && motivo && processo && anexos && preenchido && dataInicio && dataTermino;
            })
        );

    }, [treinamentos, colabName, funcSelected, obrasSelected, contratoSelected, instrutoresSelected, treinamentosSelected, motivosSelected, processosSelected, anexadoSelect, preenchidosSelected, dataIni, dataFim]);

    useEffect(() => {
        handleFilter();
    }, [handleFilter]);

    useEffect(() => {

        console.log(treinamentosFilter);

    }, [treinamentosFilter])

    useEffect(() => {

        const getTreinamentoDetail = async () => {

            if (isCreating) return;

            setLoadingItem(true);

            try {

                const { data } = await api.get(`/Painel/API/Treinamentos/GetTreinamento/index.php?id=${id}`);
                console.log(data);

            } catch (error) {

                console.log(error);

            } finally {

                setLoadingItem(false);

            }

        }

        getTreinamentoDetail();

    }, [id, isCreating])

    const closeOverlay = () => {

        navigate('/Treinamentos')

    }

    const openSidebar = () => {

        setSidebar(true);

    }

    const closeSidebar = () => {

        setSidebar(false);

    }

    const openForm = () => {

        if (!VerifyPermission(user, { modulo: "ssma", submodulo: "treinamentos", funcao: "create" })) {

            alert("Você não tem permissão para criar treinamentos.");
            return;

        }

        setSidebar(false);
        navigate('/modulo/ssma/treinamentos/form');

    }

    const closeForm = () => {

        navigate('/modulo/ssma/treinamentos');

    }

    const handleDownload = (e, url, filename) => {

        e.stopPropagation();
        saveAs(url, filename);

    }

    const [fileOverlay, setFileOverlay] = useState(false)
    const [fileId, setFileId] = useState(null)

    const openAttachment = (e, id) => {

        e.stopPropagation();

        setFileOverlay(true);
        setFileId(id);

    }

    const closeAttachment = () => {

        setFileOverlay(false);
        setFileId(null);

    }

    const downloadCertificado = async (id, name, treinamento, e) => {

        e.stopPropagation();

        setDownloadingPDF((prev) => ({ ...prev, [id]: true }));

        try {

            const { data } = await api.post('/Painel/API/Treinamentos/GenerateCertificado/', {
                id_treinamento: id
            },
                { responseType: "blob" })

            const pdfblob = new Blob([data], { type: "application/pdf" });

            saveAs(pdfblob, `${treinamento} - ${name}`)

        } catch (error) {

            console.log(error);

        } finally {

            setDownloadingPDF((prev) => ({ ...prev, [id]: false }));

        }

    }

    const [loadingList, setLoadingList] = useState(false);

    const generateLista = async () => {

        const valores = treinamentosFilter
        setLoadingList(true)

        try {

            const formData = new FormData();
            formData.append('dados', JSON.stringify(valores))

            const { data } = await api.post('/Painel/API/Treinamentos/GenerateLista/', formData, { responseType: "blob" })
            const pdfblob = new Blob([data], { type: "application/pdf" })
            saveAs(pdfblob, 'lista-de-presenca.pdf')

            console.log(data)

        } catch (error) {

            console.log(error)

        } finally {

            setLoadingList(false)

        }

    }

    const [loadingCrachas, setLoadingCrachas] = useState(false)

    const generateCrachas = async () => {

        const cpfList = [...new Set(treinamentosFilter.map(obj => obj.cpf))]
        setLoadingCrachas(true)

        await Promise.all(
            cpfList.map(async (cpf) => {

                try {

                    const formData = new FormData();
                    formData.append('cpf', cpf)

                    const { data } = await api.post('/Painel/API/Treinamentos/GenerateCracha/', formData, {
                        responseType: "blob"
                    });

                    const pdfBlob = new Blob([data], { type: 'application/pdf' })
                    saveAs(pdfBlob, `CRACHA - ${cpf}.pdf`)

                } catch (error) {

                    console.log(error)

                }

            })
        )

        setLoadingCrachas(false)

    }

    function pegarAntesDoArroba(str) {
        if (typeof str !== 'string') return null;

        const partes = str.split('@');
        return partes.length > 1 ? partes[0] : null;
    }

    const [deleteId, setDeleteId] = useState(null);
    const [deleteModal, setDeleteModal] = useState(false)

    const openDeleteModal = (e, id) => {

        e.stopPropagation();

        setDeleteId(id);
        setDeleteModal(true);

    }

    const closeDeleteModal = () => {

        setDeleteId(null)
        setDeleteModal(false)

    }

    const [savingDelete, setSavingDelete] = useState(false);

    const submitDelete = async () => {

        if (!VerifyPermission(user, { modulo: "ssma", submodulo: "treinamentos", funcao: "delete_treinamentos" })) {

            alert("Você não tem permissão para realizar esta ação.");
            closeDeleteModal();
            return;

        }

        setSavingDelete(true);

        try {

            const { data } = await api.post("/Painel/API/Treinamentos/DeleteTreinamento/", {
                id: deleteId
            }, {
                withCredentials: true
            })

            closeDeleteModal();
            getTreinamentos();

        } catch (e) {

            console.log(e)

        } finally {

            setSavingDelete(false)

        }

    }

    const [downloadingZip, setDownloadingZip] = useState(false);

    const generateZip = async () => {

        setDownloadingZip(true);

        const payload = treinamentosFilter.map(({ treinamento, nome, certificado }) => ({
            treinamento,
            nome,
            certificado
        }))

        try {

            const { data } = await api.post('/Painel/API/Treinamentos/GenerateZip/', payload, { responseType: 'blob' })

            const zipBlob = new Blob([data], { type: 'application/zip' });
            saveAs(zipBlob, 'treinamentos.zip');

        } catch (e) {

            console.log(e);

        } finally {

            setDownloadingZip(false);

        }

    }

    const openNewTreinamento = () => {

        setSidebar(false);
        openModal('addTreinamentoIndividual');

    }

    const [treinamentosGerados, setTreinamentosGerados] = useState([]);

    const fecharTreinamentosGerados = () => {

        closeModal();
        setTreinamentosGerados([]);

    }

    const containerRef = useRef(null);

    const VerifyHeight = () => {

        const element = containerRef.current;

        if (element.scrollHeight - element.scrollTop <= element.clientHeight + 10) {

            if (linhasTabela >= treinamentosFilter.length) return;
            setLinhasTabela((prev) => prev + 100);

        }

    }

    const checarValidade = (validade, data_validade) => {

        if (validade === '0' || validade === 0) {

            return "N/A"

        } else {

            return formatarData(data_validade);

        }

    }

    return (
        <>
            <NavBar
                title="TREINAMENTOS"
                setSideBar={openSidebar}
                goBackOnePage
            />
            <GenericBody>
                <GenericHeader>
                    <Filters columns={4} >
                        <FilterContainer
                            type="text"
                            placeholder="COLABORADOR..."
                            changeFunc={(value) => handleChange('name', value)}
                            valor={colabName}
                        />
                        <FilterContainer
                            type="select"
                            placeholder="FUNÇÃO..."
                            options={funcoes}
                            optType="obj"
                            changeFunc={(value) => handleChange('funcao', value)}
                        />
                        <FilterContainer
                            type="select"
                            placeholder="CENTRO CUSTO..."
                            options={obras}
                            optType="obj"
                            changeFunc={(value) => handleChange('obra', value)}
                        />
                        <FilterContainer
                            type="select"
                            placeholder="CONTRATO..."
                            options={contratos}
                            optType="obj"
                            changeFunc={(value) => handleChange('contrato', value)}
                        />
                        <FilterContainer
                            type="select"
                            placeholder="INSTRUTOR..."
                            options={instrutores}
                            changeFunc={(value) => handleChange('instrutor', value)}
                        />
                        <FilterContainer
                            type="select"
                            placeholder="TREINAMENTO..."
                            options={treinamentosOptions}
                            changeFunc={(value) => handleChange('treinamento', value)}
                        />
                        <FilterContainer
                            type="select"
                            placeholder="MOTIVO..."
                            options={motivos}
                            optType="obj"
                            changeFunc={(value) => handleChange('motivo', value)}
                        />
                        <FilterContainer
                            type="select"
                            placeholder="PROCESSO..."
                            options={processos}
                            optType="obj"
                            changeFunc={(value) => handleChange('processo', value)}
                        />
                        <FilterContainer
                            type="select"
                            placeholder="ANEXOS..."
                            options={[
                                'ANEXADO', 'ANEXO PENDENTE'
                            ]}
                            optType="obj"
                            changeFunc={(value) => handleChange('anexado', value)}
                        />
                        <FilterContainer
                            type="select"
                            placeholder="PREENCHIDO POR..."
                            options={preenchidos}
                            optType="obj"
                            changeFunc={(value) => handleChange('preenchido', value)}
                        />
                        <FilterContainer
                            type="date"
                            valor={dataIni}
                            changeFunc={(value) => handleChange('data_ini', value)}
                        />
                        <FilterContainer
                            type="date"
                            valor={dataFim}
                            changeFunc={(value) => handleChange('data_fim', value)}
                        />
                    </Filters>
                    <Stats>
                        <div style={{
                            display: 'flex',
                            flexDirection: 'column',
                            justifyContent: 'center',
                            alignItems: 'center',
                            margin: 'auto',
                            fontWeight: 'bold'
                        }} >
                            <p style={{ margin: 'auto auto 10px auto' }} >TOTAL DE TREINAMENTOS: {treinamentosFilter.length}</p>
                            <p style={{ margin: '0' }} >VÁLIDOS: {treinamentosFilter.filter(obj => obj.status === 'VALIDO').length}</p>
                            <p style={{ margin: '0' }} >A VENCER: {treinamentosFilter.filter(obj => obj.status === 'A VENCER').length}</p>
                            <p style={{ margin: '0' }} >VENCIDOS: {treinamentosFilter.filter(obj => obj.status === 'VENCIDO').length}</p>
                        </div>
                    </Stats>
                </GenericHeader>
                <ContainerTabela ref={containerRef} onScroll={VerifyHeight} >
                    {
                        loadingContent ? (
                            <LoadingWrapper>
                                <LoadingModal>
                                    <LoadingIcon />
                                    <p>CARREGANDO TREINAMENTOS...</p>
                                </LoadingModal>
                            </LoadingWrapper>
                        ) : (
                            <Tabela>
                                <thead>
                                    <tr>
                                        <th>PREENCHIDO</th>
                                        <th>COLABORADOR</th>
                                        <th>FUNÇÃO</th>
                                        <th>CONTRATO</th>
                                        <th>TREINAMENTO</th>
                                        <th>REALIZADO</th>
                                        <th>VÁLIDADE</th>
                                        <th>STATUS</th>
                                        <th></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        treinamentosFilter.slice(0, linhasTabela).map((obj) => (
                                            <LinhaTabela
                                                key={obj.id}
                                                status={obj.status}
                                                onClick={() => navigate(`/modulo/ssma/treinamentos/form/${obj.id}`)}
                                            >
                                                <td>{pegarAntesDoArroba(obj.email)}</td>
                                                <td>{obj.nome}</td>
                                                <td>{obj.funcao}</td>
                                                <td>{obj.contrato ? obj.contrato : '-'}</td>
                                                <td>{obj.treinamento_nome}</td>
                                                <td>{obj.data_termino ? formatarData(obj.data_termino) : '-'}</td>
                                                <td>{obj.validade_data ? checarValidade(obj.validade, obj.validade_data) : '-'}</td>
                                                <td>{obj.status}</td>
                                                <td>
                                                    <ContainerIcones>
                                                        <IconeContainer title="BAIXAR MODELO" >
                                                            {
                                                                downloadingPDF[obj.id] ?
                                                                    <IconeLoader />
                                                                    :
                                                                    <IconeModelo
                                                                        onClick={(e) => downloadCertificado(obj.id, obj.nome, obj.treinamento_nome, e)}
                                                                    />
                                                            }
                                                        </IconeContainer>
                                                        <IconeContainer>
                                                            {
                                                                obj.certificado ? (
                                                                    <IconeDownload title="BAIXAR CERTIFICADO" onClick={(e) => handleDownload(e, obj.certificado, obj.treinamento + ' | ' + obj.nome)} />
                                                                ) : (
                                                                    <IconeAnexar title="ANEXAR CERTIFICADO" onClick={(e) => openAttachment(e, obj.id)} />
                                                                )
                                                            }
                                                        </IconeContainer>
                                                        {
                                                            VerifyPermission(user, { modulo: "ssma", submodulo: "treinamentos", funcao: "delete_treinamentos" }) && (
                                                                <IconeContainer>
                                                                    <IconeDelete
                                                                        onClick={(e) => openDeleteModal(e, obj.id)}
                                                                    />
                                                                </IconeContainer>
                                                            )
                                                        }
                                                    </ContainerIcones>
                                                </td>
                                            </LinhaTabela>
                                        ))
                                    }
                                </tbody>
                            </Tabela>
                        )
                    }
                </ContainerTabela>
                {
                    /*<Tabela ref={tabelaRef} loading={loadingContent} >
                        <thead>
                            <tr>
                                <th>PREENCHIDO</th>
                                <th>COLABORADOR</th>
                                <th>FUNÇÃO</th>
                                <th>CONTRATO</th>
                                <th>TREINAMENTO</th>
                                <th>REALIZADO</th>
                                <th>VÁLIDADE</th>
                                <th>STATUS</th>
                                <th></th>
                                <th></th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                treinamentosFilter.slice(0, linhasTabela).map((obj) => (
                                    <tr
                                        key={obj.id}
                                        onClick={() => navigate(`/modulo/ssma/treinamentos/form/${obj.id}`)}
                                        style={{
                                            color: obj.status === 'VENCIDO' ? '#b30000' : obj.status === 'A VENCER' ? '#ff4500' : 'black',
                                            fontWeight: (obj.status === 'VENCIDO' || obj.status === 'A VENCER') ? 'bold' : 'normal'
                                        }}
                                    >
                                        <td>{pegarAntesDoArroba(obj.email)}</td>
                                        <td>{obj.nome}</td>
                                        <td>{obj.funcao}</td>
                                        <td>{obj.contrato ? obj.contrato : '-'}</td>
                                        <td>{obj.treinamento}</td>
                                        <td>{obj.data_termino}</td>
                                        <td>{obj.validade}</td>
                                        <td>{obj.status}</td>
                                        <td>
                                            <div title="BAIXAR MODELO" >
                                                {downloadingPDF[obj.id] ?
                                                    <TbLoader2
                                                        size={20}
                                                        style={{
                                                            color: "black",
                                                            animation: "spin 1s linear infinite",
                                                            "@keyframes spin": "0% { transform: rotate(0deg); } 100% { transform: rotate(360deg); }"
                                                        }}
                                                    />
                                                    :
                                                    <LuFileDown size={20} style={{ color: "black" }} onClick={(e) => downloadCertificado(obj.id, obj.nome, obj.treinamento, e)} />
                                                }
                                            </div>
                                        </td>
                                        <td>{obj.certificado ? (
                                            <HiOutlineDownload title="BAIXAR CERTIFICADO" size={20} style={{ color: "green", cursor: "pointer" }} onClick={(e) => handleDownload(e, obj.certificado, obj.treinamento + ' | ' + obj.nome)} />
                                        ) : (
                                            <div><MdOutlineAdd title="ANEXAR CERTIFICADO" size={20} style={{ color: "red", cursor: "pointer" }} onClick={(e) => openAttachment(e, obj.id)} /></div>
                                        )}</td>
                                        <td>
                                            {
                                                VerifyPermission(user, { modulo: "ssma", submodulo: "treinamentos", funcao: "delete_treinamentos" }) &&
                                                (
                                                    <ContainerBtnDelete>
                                                        <IoTrashOutline onClick={(e) => openDeleteModal(e, obj.id)} />
                                                    </ContainerBtnDelete>
                                                )
                                            }
                                        </td>
                                    </tr>
                                ))
                            }
                        </tbody>
                    </Tabela> */
                }
            </GenericBody>
            {
                sidebar &&
                <Overlay
                    state={true}
                    changeContent={closeSidebar}
                >
                    <SideMenu>
                        <SideMenuBtn
                            button="CATÁLOGO"
                            clickFunc={() => navigate("catalogo")}
                        />
                        <SideMenuBtn
                            button="CRONOGRAMA"
                            clickFunc={() => navigate("cronograma")}
                        />
                        <SideMenuBtn
                            button="GERAR ARQUIVO ZIP"
                            clickFunc={generateZip}
                            isLoading={downloadingZip}
                        />
                        <SideMenuBtn
                            button="GERAR CRACHÁ"
                            clickFunc={generateCrachas}
                            isLoading={loadingCrachas}
                        />
                        <SideMenuBtn
                            button="GERAR LISTA DE PRESENÇA"
                            clickFunc={generateLista}
                            isLoading={loadingList}
                        />
                        {
                            VerifyPermission(user, { modulo: "ssma", submodulo: "treinamentos", funcao: "create" }) && (
                                <SideMenuBtn
                                    button="TREINAMENTO P/ EQUIPE"
                                    clickFunc={openForm}
                                />
                            )
                        }
                        {
                            VerifyPermission(user, { modulo: "ssma", submodulo: "treinamentos", funcao: "create" }) && (
                                <SideMenuBtn
                                    button="TREINAMENTO INDIVIDUAL"
                                    clickFunc={openNewTreinamento}
                                />
                            )
                        }
                    </SideMenu>
                </Overlay>
            }
            {
                deleteModal &&
                <Overlay state={deleteModal} >
                    <ModalDelete>
                        <h3>Realmente deseja apagar o treinamento ?</h3>
                        <ConatinerBtnDelete>
                            <Botao tipo="cancel" disabled={savingDelete} onClick={closeDeleteModal} >CANCELAR</Botao>
                            <Botao tipo="confirm" disabled={savingDelete} onClick={submitDelete} >{
                                savingDelete ? "CARREGANDO..." : "APAGAR"
                            }</Botao>
                        </ConatinerBtnDelete>
                    </ModalDelete>
                </Overlay>
            }

            {
                openedForm &&
                <Overlay
                    state={true}
                >
                    <FormContainer
                        closeFunc={closeForm}
                    >
                        <FormTreinamentos
                            closeFunc={closeForm}
                            updateTreinamentos={getTreinamentos}
                        />
                    </FormContainer>
                </Overlay>
            }

            {

                fileOverlay &&
                <Overlay state={true} >
                    <SaveAnexos
                        close={closeAttachment}
                        idSelected={fileId}
                        updateTable={getTreinamentos}
                    />
                </Overlay>

            }
            {
                isModalOpen('addTreinamentoIndividual') && (
                    <AddTreinamentoModal
                        adicionarTreinamentos={setTreinamentosGerados}
                    />
                )
            }
            {
                isModalOpen('addedTreinamentos') && (
                    <ModalAddedTreinamentos
                        treinamentos={treinamentosGerados}
                        fechar={fecharTreinamentosGerados}
                    />
                )
            }
        </>
    )
}

export default Treinamentos;